module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/4@2x_02b68f5f0deaa1ce60bb7cb05c8b0ec7.png";